module.exports = __webpack_public_path__ + "media/customizations/trailmark/logo-b05df7401c43edc8a4cc81f7a369b5ce.png";